import ConnectedMBoxesDndArea from './ConnectedMBoxesDndArea';

export default ConnectedMBoxesDndArea;
